import React from 'react';
import NumericInput from 'react-numeric-input';
import styled from 'styled-components';

import { theme } from '../../theme';
import {
	ArrowDownStyle,
	ArrowStyle,
	ArrowUpStyle,
	InputStyles,
	StyledContainer,
	StyledSlider,
} from './range-slider.styles';

export const StyledThumb = styled.div`
	height: 12px;
	width: 12px;
	background-color: ${theme.colors.rangeSlider.background.selected};
	border-radius: 50%;
	font-size: 0;
	outline: none;
	cursor: grab;
`;

export const Thumb = (props: any, state: any) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;

export const StyledTrack = styled.div`
	top: 0;
	bottom: 0;
	background: ${(props: any) =>
		props.index === 1 ? theme.colors.rangeSlider.background.default : theme.colors.rangeSlider.background.selected};
	border-radius: 999px;
`;

export const Track = (props: any, state: any) => <StyledTrack {...props} index={state.index} />;

export const RangeSlider = () => {
	const [currentValue, setCurrentValue] = React.useState(0);
	return (
		<React.Fragment>
			<StyledContainer>
				<StyledSlider
					renderTrack={Track}
					renderThumb={Thumb}
					value={currentValue}
					onChange={(val: number) => setCurrentValue(val)}
				/>
				<NumericInput
					value={currentValue}
					onChange={(val: number) => setCurrentValue(val)}
					step={1}
					min={0}
					max={100}
					style={{
						input: InputStyles,
						btnUp: { ...ArrowStyle, ...ArrowUpStyle },
						btnDown: { ...ArrowStyle, ...ArrowDownStyle },
						arrowUp: { display: 'none' },
						arrowDown: { display: 'none' },
					}}
				/>
			</StyledContainer>
		</React.Fragment>
	);
};
